import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getMember } from '@/api/auth';
import { getUser, setUser, getToken, isDivideAccount } from '@/utils/auth';

export default function Footer() {
  const cached = getUser();
  const [enterpriseName, setEnterpriseName] = useState(
    () => cached?.enterprise?.title || ''
  );
  const [enterpriseAddress, setEnterpriseAddress] = useState(
    () => (typeof cached?.enterprise?.address === 'string' ? cached.enterprise.address : '') || ''
  );
  const [showProxyOrder, setShowProxyOrder] = useState(() => isDivideAccount(cached));

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const res = await getMember();
        if (cancelled) return;

        const ok = res.error === false || Number(res.error) === 0;
        if (ok && res.data) {
          const name = res.data.enterprise?.title || '';
          const address =
            typeof res.data.enterprise?.address === 'string'
              ? res.data.enterprise.address
              : '';
          setEnterpriseName(name);
          setEnterpriseAddress(address);
          const token = getToken() || undefined;
          const nextUser = {
            ...res.data,
            token,
            is_canedit: res.data.is_canedit ?? res.is_canedit,
            is_divide: res.data.is_divide ?? res.is_divide,
          };
          setUser(nextUser);
          setShowProxyOrder(isDivideAccount(nextUser));
        }
      } catch {
        // 498 等由请求拦截器统一处理
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <footer className="bg-background-100 border-t border-background-200 shrink-0">
      <div className="px-6 md:px-10 lg:px-16 pt-4 pb-5">
        <div className="grid grid-cols-1 md:grid-cols-[12fr_4fr_4fr_4fr] gap-6 md:gap-8">
          <div className="min-w-0">
            <h3 className="text-base font-bold text-foreground-900 mb-3">邕宜购</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {enterpriseName || '物资线上采购平台'}
            </p>
            {enterpriseAddress ? (
              <p className="text-xs text-foreground-400 mt-1.5 leading-relaxed">
                {enterpriseAddress}
              </p>
            ) : null}
          </div>
          <div className="min-w-0">
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">帮助中心</h4>
            <ul className="space-y-2">
              <li><Link to="/goods" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">平台介绍</Link></li>
              <li><Link to="/goods" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">使用指南</Link></li>
              <li><Link to="/goods" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">常见问题</Link></li>
            </ul>
          </div>
          <div className="min-w-0">
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">服务支持</h4>
            <ul className="space-y-2">
              <li><Link to="/goods" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">物资目录</Link></li>
              <li><Link to="/orders" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">订单查询</Link></li>
              <li><Link to="/after-sales" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">售后申请</Link></li>
            </ul>
          </div>
          <div className="min-w-0">
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">快捷入口</h4>
            <ul className="space-y-2">
              {showProxyOrder && (
                <li><Link to="/proxy-order" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">代购下单</Link></li>
              )}
              <li><Link to="/frequent-purchase" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">常购清单</Link></li>
              <li><Link to="/reports" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">数据报表</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200 mt-4 pt-4 flex flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 邕宜购物资线上采购平台 —— 专注医疗物资一站式采购服务
          </p>
          <div className="flex items-center gap-4">
            <Link to="/goods" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">隐私政策</Link>
            <Link to="/goods" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">使用条款</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
